import React from 'react'
import Slides from '../slides/Slides'
import Footer from '../footer/Footer'
import iconContactoMasculino from "../../img/iconContactoMasculino.jpg";

const ServicioDeAtencion = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides="serviciodetencion"/>
         <div className="section animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3">SERVICIO DE ATENCIÓN AL ASEGURADO</h4>
               <div className="container justify grey-text text-darken-1">
                  <blockquote>
                     <p className="font-size-18">
                        <strong>
                           <em>
                              La compañia de seguros LATITUD SUR S.A.  dispone de un Servicio de Atención al Asegurado que atenderá las consultas y
                              reclamos que presenten los tomadores de seguros, asegurados, beneficiarios y/o derechohabientes.. 
                           </em>
                        </strong>
                     </p>
                  </blockquote>
                  <h5 className="light-blue-text text-accent-3">El servicio mencionado está integrado por: </h5>
                  <div className="row">
                     <div className="col s12 m12 l6 x6">
                        <div className="card-panel grey lighten-5 z-depth-1">
                           <div className="row valign-wrapper">
                              <div className="col s2">
                                 <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                              </div>
                              <div className="col s10">
                                 <span className="black-text">
                                    <strong>Responsable</strong><br/>
                                    <strong>Ramiro Javier Montero</strong><br/>
                                    0388 - 4911741 Int.: 302<br/>
                                    rmontero@latitudsursa.com.ar
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="col s12 m12 l6 x6">
                        <div className="card-panel grey lighten-5 z-depth-1">
                           <div className="row valign-wrapper">
                              <div className="col s2">
                                 <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                              </div>
                              <div className="col s10">
                                 <span className="black-text">
                                    <strong>Suplente</strong><br/>
                                    <strong>José Prudencio Gutiérrez</strong><br/>
                                    0388 - 4911741 Int.: 127<br/>
                                    jgutierrez@latitudsursa.com.ar
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <blockquote>
                     <p className="font-size-18">
                        <strong>
                           <em>
                              En caso de que existiera un reclamo ante la entidad aseguradora y que el mismo no haya sido resuelto o haya sido desestimado, total o parcialmente, 
                              o que haya sido denegada su admisión, podrá comunicarse con la Superintendencia de Seguros de la Nación a través del sitio web oficial  
                              <a href="https://www.argentina.gob.ar/ssn" target="blank"> argentina.gob.ar/ssn</a>
                           </em>
                        </strong>
                     </p>
                  </blockquote>
               </div>
            </div>      
         </div>
      </>
   )
}

export default ServicioDeAtencion